import { PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS } from "../../../types";
import PersonalSettingsSpacesTableItemRowCellSpace from "./CellSpace";
import PersonalSettingsSpacesTableItemRowCellPermissions from "./CellPermissions";
import PersonalSettingsSpacesTableItemRowCellDescription from "./CellDescription";
import { PersonalSettingsSpacesRenderItemRowProps } from "../../../types";

export type RenderItemRowCellProps = {
  cellId: string;
  isFirst: boolean;
} & Pick<PersonalSettingsSpacesRenderItemRowProps, "row">;

const CELL_PER_COLUMN = {
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.PERMISSIONS]:
    PersonalSettingsSpacesTableItemRowCellPermissions,
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.DESCRIPTION]:
    PersonalSettingsSpacesTableItemRowCellDescription,
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.SPACE]: PersonalSettingsSpacesTableItemRowCellSpace,
};

type PersonalSettingsSpacesTableItemRowContentProps = PersonalSettingsSpacesRenderItemRowProps;

const PersonalSettingsSpacesTableItemRowContent = ({
  columns,
  row,
}: PersonalSettingsSpacesTableItemRowContentProps) => {
  const cellProps = {
    row,
  };

  return columns.map((column, i) => {
    const Cell = CELL_PER_COLUMN[column.id as PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS];
    const cellId = `${row.id}-${column.id}`;

    return <Cell key={cellId} cellId={cellId} isFirst={i === 0} {...cellProps} />;
  });
};

export default PersonalSettingsSpacesTableItemRowContent;
